import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError } from 'rxjs/operators';
import * as SupplierlistActions from './Supplierlist.action';
import { NSAdminbuysellRuleserviceService } from '../../Clients/NS/Services/NSAdminbuysellRuleservice.service';

@Injectable()
export class SupplierlistEffects {
  loadSuppliers$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupplierlistActions.loadSuppliers),
      mergeMap(() =>
        this.supplierService.GetSupplierlist().pipe(
          map((suppliers) =>
            SupplierlistActions.loadSuppliersSuccess({ suppliers })
          ),
          catchError((error) =>
            of(
              SupplierlistActions.loadSuppliersFailure({ error: error.message })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private supplierService: NSAdminbuysellRuleserviceService
  ) {}
}
